import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Flex, Image } from 'rebass/styled-components';
import { CircleCheckBig } from 'lucide-react';
import Comp from '../../../assets/companies-large/compa.svg';
import IndexVentures from '../../../assets/companies-large/indexVentures.svg';
import Solana from '../../../assets/companies-large/solana.svg';
import Invisible from '../../../assets/companies-large/invisible.svg';
import Techstars from '../../../assets/companies-large/techstars.svg';
import FlyFlat from '../../../assets/companies-large/flyFlat.svg';

const VALUE_PROPS = [
  'Showcase your employer brand',
  'Get referred top talent',
  { bold: 'Publish open roles ', normal: "if you don't have an ATS" },
  'Get hire-ready candidates from AI agents',
];

export const ClaimProfileSidebar = ({ networkName }) => (
  <Box
    sx={{
      background: 'radial-gradient(243.75% 127.19% at 51.98% 100%, #7E16FF 0%, #4900FF 75.94%, #00005A 100%)',
      flexDirection: 'column',
      alignItems: 'flex-start',
      height: '100vh',
      width: '480px',
      minWidth: '480px',
      display: ['none', 'none', 'flex'],
      p: '80px 40px',
      justifyContent: 'space-between',
      position: 'fixed',
      right: 0,
      zIndex: 1000,
    }}
  >
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        width: '400px',
      }}
    >
      <Text sx={{ fontSize: '28px', fontWeight: '700', color: 'neutral.0', lineHeight: '1.2' }}>
        Accelerate hiring with {networkName}
      </Text>

      <Flex sx={{ flexDirection: 'column', gap: '8px', width: '100%' }}>
        {VALUE_PROPS.map((item) => (
          <Flex key={typeof item === 'string' ? item : item.bold} sx={{ gap: '8px', alignItems: 'center' }}>
            <Box as={CircleCheckBig} size={16} sx={{ color: 'neutral.0', flexShrink: 0 }} />
            <Text sx={{ fontSize: '16px', fontWeight: 500, color: 'neutral.0', lineHeight: '1.4' }}>
              {typeof item === 'string' ? (
                item
              ) : (
                <>
                  {item.bold}
                  <Text as="span" sx={{ fontWeight: 400 }}>
                    {item.normal}
                  </Text>
                </>
              )}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Flex>

    <Flex sx={{ flexDirection: 'column', alignItems: 'center', gap: '8px', width: '400px' }}>
      <Text
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          color: 'neutral.0',
          opacity: 0.7,
          textAlign: 'center',
          width: '100%',
        }}
      >
        Trusted by top investors and companies
      </Text>
      <Flex sx={{ columnGap: '24px', rowGap: '8px', flexWrap: 'wrap', justifyContent: 'center', opacity: 0.9 }}>
        <Image src={Comp} alt="Compa logo" />
        <Image src={Techstars} alt="Techstars logo" />
        <Image src={Invisible} alt="Invisible logo" />
        <Image src={IndexVentures} alt="Index Ventures logo" />
        <Image src={Solana} alt="Solana logo" />
        <Image src={FlyFlat} alt="FlyFlat logo" />
      </Flex>
    </Flex>
  </Box>
);

ClaimProfileSidebar.propTypes = {
  networkName: PropTypes.string,
};

ClaimProfileSidebar.defaultProps = {
  networkName: '',
};
